/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AggregatedCurveDataDto } from './aggregatedCurveDataDto';

/**
 * Aggregated Curve ack DTO
 */
export interface AggregatedCurveAckDto {
  buyTradesCount: number;
  sellTradesCount: number;
  /**
   * Quantity in specified time filter
   */
  totalTradeQuantity: number;
  data: Array<AggregatedCurveDataDto>;
  /**
   * The data that is grouped by LP ids. For example \'Best expected\' trade curve which is a result of combining best trade curve points from different LPs
   */
  groupedData?: Array<AggregatedCurveDataDto>;
}
